module.exports = __webpack_public_path__ + "img/13.db42f26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/13.jpg
// module id = 205
// module chunks = 1